module.exports = __webpack_public_path__ + "static/media/without-title.e3f8a0e7.svg";